export function getNegativeValueInAccountingForm(value:any) {
    if (!value) {
        return '$0';
    }

    if (value < 0) {
        return `($${value * -1})`;
    }
    else {
        return `$${value}`;
    }
}